import React from "react";
import { ComingSoon } from "../../Components/ComingSoon/ComingSoon";

// TODO: Placeholder until the analytics metrics and API are defined.
export const Analytics: React.FC = () => (
  <ComingSoon title="Analytics" breadCrumb="Analytics" path="/analytics" message="Analytics dashboard is coming soon." />
);
